export default __webpack_public_path__ + "assets/images/009804cb48be5a5d7b89caa0a15aecd7.png";